export default {

	"payment_processing": {
		"en": "Payment processing",
		"pl": "Przetwarzanie płatności",
		"ru": "Обработка платежа",
		"ua": "Обробка платежу"
	},

	"payment_failed": {
		"en": "Payment failed!",
		"pl": "Płatność nie powiodła się!",
		"ru": "Платеж не прошел!",
		"ua": "Не вдалося оплатити!"
	},

	"fee_has_been_paid": {
		"en": "The fee has been paid!",
		"pl": "Opłata została uiszczona!",
		"ru": "Взнос оплачен!",
		"ua": "Збір сплачено!"
	},

	"payment_pending_warning": {
		"en": "Please be patient, your payment is being processed. You can refresh the status with the button below.",
		"pl": "Proszę o chwilę cierpliwości, płatność jest w trakcie przetwarzania. Możesz odświeżyć status przyciskiem niżej.",
		"ru": "Пожалуйста, подождите, ваш платеж обрабатывается. Вы можете обновить статус с помощью кнопки ниже.",
		"ua": "Будь ласка, наберіться терпіння, ваш платіж обробляється. Ви можете оновити статус за допомогою кнопки нижче."
	},

	"payment_success_subheading": {
		"en": "Thank you for making the payment. You can download the payment\nconfirmation below by clicking the \"download confirmation\" button.",
		"pl": "Dziękujemy za dokonanie płatności. Potwierdzenie płatności możesz\npobrać poniżej klikając w przycisk \"pobierz potwierdzenie\".",
		"ru": "Спасибо за оплату. Вы можете скачать подтверждение платежа ниже,\nнажав кнопку \"загрузить подтверждение\".",
		"ua": "Дякуємо, що здійснили платіж. Ви можете завантажити підтвердження\nплатежу нижче, натиснувши кнопку \"Завантажити підтвердження\"."
	},

	"payment_success_warning": {
		"en": "A link to download the document has also been sent to your e-mail address or by SMS to the provided phone number. For security reasons, the file has been password protected. If you chose the method of confirming the reservation by means of an SMS code, the password to the file will be your telephone number, in the case of confirmation using an e-mail address - the password to the file will be your e-mail address.",
		"pl": "Link do pobrania dokumentu został również wysłany na Twój adres E-mail lub SMS-em na podany numer telefonu. Ze względów bezpieczeństwa plik został zabezpieczony hasłem. Jeżeli wybrałeś metodę potwierdzenia rezerwacji za pomocą kodu SMS, hasłem do pliku będzie Twój numer telefonu, w przypadku potwierdzenia za pomocą adresu e-mail - hasłem do pliku będzie Twój adres e-mail.",
		"ru": "Ссылка для скачивания документа также была отправлена ​​на Ваш адрес электронной почты или в виде SMS на указанный номер телефона. В целях безопасности файл защищен паролем. Если вы выбрали способ подтверждения бронирования с помощью смс-кода, то паролем к файлу будет ваш номер телефона, в случае подтверждения с помощью адреса электронной почты - паролем к файлу будет ваш e-mail.",
		"ua": "Посилання для завантаження документа також надіслано на вашу електронну адресу або за допомогою SMS на вказаний номер телефону. З міркувань безпеки файл захищено паролем. Якщо ви вибрали спосіб підтвердження бронювання за допомогою SMS-коду, паролем до файлу буде ваш номер телефону, у разі підтвердження за допомогою адреси електронної пошти - паролем до файлу буде ваш e-mail."
	},

	"download_confirmation": {
		"en": "Download confirmation",
		"pl": "Pobierz potwierdzenie",
		"ru": "Загрузить подтверждение",
		"ua": "Завантажити підтвердження"
	},

	"refresh_status": {
		"en": "REFRESH STATUS",
		"pl": "ODŚWIEŻ STATUS",
		"ru": "ОБНОВИТЬ СТАТУС",
		"ua": "ОНОВИТИ СТАТУС"
	},
}